import { render, staticRenderFns } from "./RequirementList.vue?vue&type=template&id=1ee52a1b"
import script from "./RequirementList.vue?vue&type=script&lang=js"
export * from "./RequirementList.vue?vue&type=script&lang=js"
import style0 from "./RequirementList.vue?vue&type=style&index=0&id=1ee52a1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports